var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "el-row-line" },
        [
          _c("PageInfo"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: { click: _vm.addApp },
            },
            [_c("i", { staticClass: "el-icon-circle-plus" }), _vm._v(" 新建")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                { attrs: { model: _vm.searchForm, inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入账号",
                          "prefix-icon": "el-icon-search",
                        },
                        model: {
                          value: _vm.searchForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "name", $$v)
                          },
                          expression: "searchForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入用户名",
                          "prefix-icon": "el-icon-search",
                        },
                        model: {
                          value: _vm.searchForm.real_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "real_name", $$v)
                          },
                          expression: "searchForm.real_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          clearable: "",
                          placeholder: "请输入手机号",
                          "prefix-icon": "el-icon-search",
                        },
                        model: {
                          value: _vm.searchForm.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "mobile", $$v)
                          },
                          expression: "searchForm.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: "请选择角色",
                          },
                          model: {
                            value: _vm.searchForm.role_ids,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "role_ids", $$v)
                            },
                            expression: "searchForm.role_ids",
                          },
                        },
                        _vm._l(_vm.querySelectOptions, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "超管" },
                          model: {
                            value: _vm.searchForm.is_sup,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "is_sup", $$v)
                            },
                            expression: "searchForm.is_sup",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _vm._v(" "),
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "投手" },
                          model: {
                            value: _vm.searchForm.is_pitcher,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "is_pitcher", $$v)
                            },
                            expression: "searchForm.is_pitcher",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _vm._v(" "),
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "设计师" },
                          model: {
                            value: _vm.searchForm.is_designer,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "is_designer", $$v)
                            },
                            expression: "searchForm.is_designer",
                          },
                        },
                        [
                          _c("el-option", { attrs: { label: "是", value: 1 } }),
                          _vm._v(" "),
                          _c("el-option", { attrs: { label: "否", value: 0 } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "状态" },
                          model: {
                            value: _vm.searchForm.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "state", $$v)
                            },
                            expression: "searchForm.state",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 1, label: "正常" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { value: 0, label: "禁用" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData(1)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-search" }),
                          _vm._v(" 搜索"),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            { attrs: { stripe: "", data: _vm.listData, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "账号", width: "200" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "邮箱", width: "200" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "real_name", label: "用户", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", width: "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "branch", label: "部门", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.branch, function (item, index) {
                        return _c("el-tag", { key: index }, [
                          _vm._v(_vm._s(item)),
                        ])
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_sup", label: "超管", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_sup
                          ? _c("el-tag", { attrs: { type: "" } }, [
                              _vm._v("是"),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("否"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_pitcher", label: "投手", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_pitcher
                          ? _c("el-tag", { attrs: { type: "" } }, [
                              _vm._v("是"),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("否"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_designer", label: "设计师", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_designer
                          ? _c("el-tag", { attrs: { type: "" } }, [
                              _vm._v("是"),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("否"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_kefu", label: "客服", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.is_kefu
                          ? _c("el-tag", { attrs: { type: "" } }, [
                              _vm._v("是"),
                            ])
                          : _c("el-tag", { attrs: { type: "info" } }, [
                              _vm._v("否"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "is_sensitive", label: "敏感用户" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.is_sensitive === 1
                                  ? "primary"
                                  : "info",
                              "disable-transitions": "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.is_sensitive === 1 ? "是" : "否")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "role_ids", label: "角色", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (slotProps) {
                      return _vm._l(
                        slotProps.row.role_ids,
                        function (item, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticStyle: { "margin-left": "5px" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.getName(item, _vm.querySelectOptions)
                                )
                              ),
                            ]
                          )
                        }
                      )
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applys", label: "授权应用", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.applys, function (item) {
                        return _c(
                          "el-tag",
                          { key: item.id, attrs: { type: "primary" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.app_name) +
                                "\n          "
                            ),
                          ]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创建时间", prop: "created_at", width: "145" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "最后登录时间",
                  prop: "last_login_time",
                  width: "145",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "allow_web_login",
                  label: "账号密码登录",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.allow_web_login === 1
                                  ? "primary"
                                  : "danger",
                              "disable-transitions": "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                scope.row.allow_web_login === 1
                                  ? "允许"
                                  : "禁止"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "状态", width: "60px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.state === 1 ? "primary" : "danger",
                              "disable-transitions": "",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(scope.row.state === 1 ? "正常" : "禁用")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", icon: "el-icon-edit" },
                            on: {
                              click: function ($event) {
                                return _vm.tableEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { float: "right", margin: "20px 0px" },
            attrs: {
              background: "",
              "pager-count": 5,
              "hide-on-single-page": "",
              "current-page": _vm.pagination.page,
              "page-sizes": [20, 50, 100],
              "page-size": _vm.pagination.limit,
              total: _vm.pagination.total,
              layout: "total,sizes,prev, pager, next",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "size-change": _vm.handlePageSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-press-escape": !1,
            "close-on-click-modal": !1,
            title: _vm.isEdit ? "编辑" : "新增",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "userForm",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.rules,
                "label-width": "110px",
                "label-position": "right",
              },
            },
            [
              _vm.isEdit
                ? _c(
                    "el-form-item",
                    { attrs: { label: "ID:", prop: "id" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "", placeholder: "ID" },
                        model: {
                          value: _vm.dataForm.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "id", $$v)
                          },
                          expression: "dataForm.id",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "账号", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入账号" },
                    model: {
                      value: _vm.dataForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "name", $$v)
                      },
                      expression: "dataForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入邮箱", clearable: "" },
                    model: {
                      value: _vm.dataForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "email", $$v)
                      },
                      expression: "dataForm.email",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "用户", prop: "real_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入用户名" },
                    model: {
                      value: _vm.dataForm.real_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "real_name", $$v)
                      },
                      expression: "dataForm.real_name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入密码" },
                    model: {
                      value: _vm.dataForm.newPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "newPassword", $$v)
                      },
                      expression: "dataForm.newPassword",
                    },
                  }),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#909399",
                            "font-size": "12px",
                            margin: "0 0 0 10px",
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-info" }),
                          _vm._v("填写将修改密码"),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.dataForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "mobile", $$v)
                      },
                      expression: "dataForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        placeholder: "请选择角色",
                        filterable: "",
                        clearable: "",
                      },
                      model: {
                        value: _vm.dataForm.role_ids,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "role_ids", $$v)
                        },
                        expression: "dataForm.role_ids",
                      },
                    },
                    _vm._l(_vm.querySelectOptions, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "超管", prop: "is_sup" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.dataForm.is_sup,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "is_sup", $$v)
                      },
                      expression: "dataForm.is_sup",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "投手", prop: "is_pitcher" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.dataForm.is_pitcher,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "is_pitcher", $$v)
                      },
                      expression: "dataForm.is_pitcher",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "设计师", prop: "is_designer" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.dataForm.is_designer,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "is_designer", $$v)
                      },
                      expression: "dataForm.is_designer",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "敏感用户" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "是",
                      "inactive-text": "否",
                    },
                    model: {
                      value: _vm.dataForm.is_sensitive,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "is_sensitive", $$v)
                      },
                      expression: "dataForm.is_sensitive",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "账号密码登录" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "允许",
                      "inactive-text": "禁止",
                    },
                    model: {
                      value: _vm.dataForm.allow_web_login,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "allow_web_login", $$v)
                      },
                      expression: "dataForm.allow_web_login",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "state" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-text": "启用",
                      "inactive-text": "禁用",
                    },
                    model: {
                      value: _vm.dataForm.state,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "state", $$v)
                      },
                      expression: "dataForm.state",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-error" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-success" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }